export type Lecture = {
  id: string; // e.g. "01-vorbereitung"
  num: string; // e.g. "01"
  title: string; // e.g. "Vorbereitung"
  subtitle: string; // short description shown in sidebar
  component: string; // component name for lazy loading
};

export type Course = {
  id: string;
  title: string;
  description: string;
  color: string; // accent color per course (all blue-ish for your theme)
  lectures: Lecture[];
};

export const COURSES: Course[] = [
  {
    id: "ausbildung-preparatory",
    title: "Ausbildung Preparatory",
    description: "Kick-off bis Ausbildungsstart",
    color: "#009fe3",
    lectures: [
      {
        id: "01-vorbereitung",
        num: "01",
        title: "Vorbereitung",
        subtitle: "Kick-off · Dokumente · Foto",
        component: "Lecture01Vorbereitung",
      },
      {
        id: "02-lebenslauf",
        num: "02",
        title: "Lebenslauf",
        subtitle: "CV Aufbau · Struktur",
        component: "Lecture02Lebenslauf",
      },
      {
        id: "03-stellenausschreibung",
        num: "03",
        title: "Stellenausschreibung",
        subtitle: "Job Posting",
        component: "Lecture03Stellenausschreibung",
      },
      {
        id: "04-anschreiben",
        num: "04",
        title: "Anschreiben",
        subtitle: "Portale · Tipps",
        component: "Lecture04AnschreibenDIN5008",
      },
      {
        id: "05-unterlagenkontrolle",
        num: "05",
        title: "Unterlagenkontrolle",
        subtitle: "Dokumente prüfen",
        component: "Lecture05Unterlagenkontrolle",
      },
      {
        id: "06-erfolgreich-bewerben",
        num: "06",
        title: "Erfolgreich Bewerben",
        subtitle: "Tipps & Tricks",
        component: "Lecture06ErfolgreichBewerben",
      },
      {
        id: "07-application-tracking",
        num: "07",
        title: "Application Tracking",
        subtitle: "Bewerbungsstatus verfolgen",
        component: "Lecture07ApplicationTracker",
      },
      {
        id: "08-ausbildung-suche",
        num: "08",
        title: "Ausbildung Suche",
        subtitle: "Gezielte Suchstrategien",
        component: "Lecture08AusbildungSuche",
      },
      {
        id: "09-application-review",
        num: "09",
        title: "Application Review",
        subtitle: "Review ausbildung application",
        component: "Lecture09ApplicationReview",
      },
      {
        id: "10-unterkunft",
        num: "10",
        title: "Unterkunft",
        subtitle: "Wohnung · Unterkunft · Tipps",
        component: "Lecture10Unterkunft",
      },
      // Add more as you convert each PPT
    ],
  },
  {
    id: "au-pair-preparatory",
    title: "Au Pair Preparatory",
    description: "Finding AU Pair and Visa",
    color: "#0369a1",
    lectures: [
      {
        id: "01-introduction",
        num: "01",
        title: "Introduction",
        subtitle: "Overview & Objectives",
        component: "AuPairLecture01Introduction",
      },
      {
        id: "02-culture-profile",
        num: "02",
        title: "Culture & Profile",
        subtitle: "Understanding Cultural Differences",
        component: "AuPairLecture02CultureProfile",
      },
      {
        id: "03-host-family-search",
        num: "03",
        title: "Host Family Search",
        subtitle: "Finding the Right Host Family",
        component: "Aupairlecture03hostfamilysearch",
      },
    ],
  },
  {
    id: "fsj-bfd-preparatory",
    title: "FSJ/BFD Preparatory",
    description: "Finding FSJ/BFD and Visa",
    color: "#7c3aed",
    lectures: [
      {
        id: "01-introduction-overview",
        num: "01",
        title: "Introduction & Overview",
        subtitle: "Ist FSJ/BFD für dich geeignet?",
        component: "FSJLecture01Introduction",
      },
      {
        id: "03-docs-application",
        num: "03",
        title: "Docs & Application",
        subtitle: "Bewerbungsunterlagen & Antrag",
        component: "FSJLecture03Application",
      },
    ],
  },
  {
    id: "visum-einreise",
    title: "Visum & Einreise",
    description: "Antrag · Dokumente · Einreise",
    color: "#059669",
    lectures: [
      {
        id: "01-visum-typen",
        num: "01",
        title: "Visum Typen",
        subtitle: "Welches Visum?",
        component: "V_Lecture01VisumTypen",
      },
    ],
  },
];

export const getCourseById = (id: string): Course | undefined =>
  COURSES.find((c) => c.id === id);

export const getLectureById = (
  course: Course,
  lectureId: string,
): Lecture | undefined => course.lectures.find((l) => l.id === lectureId);
